/**
  The hexToRgb() function helps you to change the hex color code to rgb
  using native JavaScript.
 */

function hexToRgb(color: any) {
  // Remove # if present
  const hex = color.replace('#', '');
  
  // Parse hex color
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  return `${r}, ${g}, ${b}`;
}

export default hexToRgb;
